import { environment } from '@environment';
import { formatDate } from '@shared/core/utils';
import { NativeDateTimeAdapter } from '../../../vendor/ng-pick-datetime/native-date-time-adapter.class';
import { Injectable } from '@angular/core';

export const PICK_DATETIME_CUSTOM_DATE_FORMAT = {
  parseInput: environment.serverDateTimeFormat,
  fullPickerInput: 'dd.MM.yyyy HH:mm',
  datePickerInput: 'dd.MM.yyyy',
  timePickerInput: 'HH:mm:ss',
  monthYearLabel: 'LLLL yyyy',
  dateA11yLabel: 'd MMMM yyyy',
  monthYearA11yLabel: 'LLLL yyyy',
};

@Injectable()
export class PickDatetimeDateAdapter extends NativeDateTimeAdapter {
  format(date: Date, displayFormat: string): string {
    return formatDate(date, displayFormat, this.locale);
  }
}
